import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authorizer: {},
    user: {},
    charts: {},
    sidebar: {
      // 数据相关
      data: {
        // 实时
        'sp_v2_realtime': [
          '/data/sp_v2_realtime/overview'
        ],
        // 用户
        'sp_v2_user': [
          '/data/sp_v2_user/overview',
          '/data/sp_v2_user/new',
          '/data/sp_v2_user/details'
        ],
        // 行为
        'sp_v2_behavior': [
          '/data/sp_v2_behavior/overview',
          '/data/sp_v2_behavior/share'
        ],
        // 实时
        'sp_realtime': [
          '/data/sp_realtime/overview'
        ],
        // 用户
        'sp_user': [
          '/data/sp_user/overview',
          '/data/sp_user/new',
          '/data/sp_user/details'
        ],
        // 行为
        'sp_behavior': [
          '/data/sp_behavior/overview',
          '/data/sp_behavior/share'
        ],
        // 实时
        'realtime': [
          '/data/realtime/overview'
        ],
        // 实时
        'user': [
          '/data/user/overview',
          '/data/user/new',
          '/data/user/details'
        ],
        // 行为
        'behavior': [
          '/data/behavior/mp',
          '/data/behavior/h5',
          '/data/behavior/link'
        ],
        // 内容
        'content': [
          '/data/content/index',
          '/data/content/details'
        ],
        // 京东活动数据
        'utm_data': [
          '/data/utm/index'
        ],
        // 京东店铺人群画像
        'insight': [
          '/data/utm/insight'
        ]
      },
      // 人群包
      package: {
        // 人群包筛选
        'package_filter': [
          '/package/package_filter'
        ],
        // 小程序人群包筛选
        'sp_package_filter': [
          '/package/sp_package_filter'
        ]
      },
      // 微信公众号设置
      mp: {
        // 微信素材管理
        'material': [
          '/mp/material/picture',
          '/mp/material/video',
          '/mp/material/audio',
          '/mp/material/article',
          '/mp/material/drafts',
          '/mp/material/material'
        ],
        // 回复素材管理
        'reply': [
          '/mp/reply/article',
          '/mp/reply/video',
          '/mp/reply/text',
          '/mp/reply/mini'
        ],
        // 菜单管理
        'menu': [
          '/mp/menu/layout',
          '/mp/menu/release'
        ],
        // 用户分组管理
        'group': [
          '/mp/group/index',
          '/mp/group/user'
        ],
        // 基础功能
        'system': [
          '/mp/system/reply',
          '/mp/system/qrcode',
          '/mp/system/mass',
          '/mp/system/shorturl'
        ],
        // 高级功能
        'custom': [
          '/mp/custom/template',
          '/mp/custom/message',
          '/mp/custom/package',
          '/mp/custom/track_reply',
          '/mp/custom/user_tag'
        ]
      },
      // 应用设置
      setting: {
        // 京东活动链接管理
        'link': [
          '/setting/utm/link'
        ],
        // 京东活动分组管理
        'utm': [
          '/setting/utm/group',
          '/setting/utm/link'
        ],
        // 监控管理
        'track': [
          '/setting/track/group',
          '/setting/track/link',
          '/setting/track/event',
          '/setting/track/shortlink'
        ],
        // 标签设置
        'tag': [
          '/setting/tag/type',
          '/setting/tag/manage'
        ],
        // 小程序设置
        'mini': [
          '/setting/mini/group',
          '/setting/mini/custom',
          '/setting/mini/channel',
          '/setting/mini/scheme',
          '/setting/mini/link'
        ],
        // 小程序设置
        'app': [
          '/setting/app/group',
          '/setting/app/custom'
        ]
      },
      // 系统管理
      system: {
        'system': [
          '/system/system/customer',
          '/system/system/authorizer',
          '/system/system/mini',
          '/system/system/app',
          '/system/system/tenant',
          '/system/system/user'
        ]
      }
    }
  },
  getters: {
    authorizer: (state) => {
      return state.authorizer
    },
    user: (state) => {
      return state.user
    },
    sidebar: (state) => {
      return state.sidebar
    }
  },
  mutations: {
  },
  actions: {
    authorizer ({ commit }, data) {
      this.state.authorizer = data
    },
    user ({ commit }, data) {
      this.state.user = data
    }
  },
  modules: {
  }
})
